export default function RulesOfTeam() {
  return (
    <div className="mb-4 bg-primary bg-opacity-10 border border-primary/10 rounded-md p-4">
      <ul className="text-sm text-primary list-disc list-inside">
        {/* {t("team.draft_submit_message")} */}
        <li>
          {" "}
          ТІРКЕУДІ АЯҚТАУ батырмасын барлық оқушыны дұрыс енгізгеннен кейін ғана
          басыңыз.{" "}
        </li>
        <li> Бір жетекші бір топты, яғни 3 оқушыны ғана тіркей алады. </li>
        <li>
          {" "}
          Оқушының мәліметі толық, әрі дұрыс енгізілгеніне көз жеткізіңіз.{" "}
        </li>
        <li>
          Топтың барлық мүшесі дұрыс енгізілгеннен кейін, топты олимпиадаға
          тіркеу үшін, ТІРКЕУДІ АЯҚТАУ батырмасын басыңыз.{" "}
        </li>
        <li>
          {" "}
          ТІРКЕУДІ АЯҚТАУ батырмасы басылғаннан кейін, топтың, оқушының
          мәліметін өңдеуге, өзгертуге мүмкіншілік болмайды.{" "}
        </li>
      </ul>
    </div>
  );
}
